module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.tag, {
    tag: "component",
    staticClass: "fields field-section",
    style: ({
      'color': _vm.color
    })
  }, [(_vm.lastSection.tid) ? _c('term-link', {
    attrs: {
      "tid": _vm.lastSection.tid,
      "title": _vm.lastSection.title,
      "url": _vm.lastSection.relative_url,
      "type": _vm.lastSection.type
    }
  }, [_vm._v("\n             " + _vm._s(_vm.truncate(_vm.lastSection.title, {
    length: _vm.truncateLength > 0 ? this.truncateLength : 999,
    separator: /,? +/,
  })) + "\n             ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-187b9bdf","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/fields/Section.vue
// module id = 985
// module chunks = 1 2 3 6 24